export function getQueryParam(paramName: string) {
    if (typeof window === 'undefined') return null;
    const queryParams = new URLSearchParams(window.location.search);
    const value = queryParams.get(paramName);
    return value;
}

export function getQueryParams(paramName: string) {
    if (typeof window === 'undefined') return null;
    const queryParams = new URLSearchParams(window.location.search);
    const values = queryParams.getAll(paramName);

    return values;
}

export const randomString = (length: number): string => {
    let result = '';
    const characters =
        'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789';
    for (let i = 0; i < length; i++) {
        result += characters.charAt(
            Math.floor(Math.random() * characters.length),
        );
    }
    return result;
};

export function isPanelId(id: string): boolean {
    return id.startsWith('panel-');
}

export function isStudyId(id: string): boolean {
    return id.startsWith('study-');
}

const commands = {
    bookingCompleted: {
        data: {},
    },
    closeWidget: {
        data: {},
    },
    isDisqualified: {
        data: {},
    },
};

export function sendMessageOverWebview(command: keyof typeof commands) {
    const data = JSON.stringify({ data: commands[command].data, command });
    if (window.ReactNativeWebView) {
        window.ReactNativeWebView.postMessage(data);
    }

    if (window.uxsignals && window.uxsignals.postMessage) {
        window.uxsignals.postMessage(data);
    }

    if (
        window.webkit &&
        window.webkit.messageHandlers &&
        window.webkit.messageHandlers.uxsignals
    ) {
        window.webkit.messageHandlers.uxsignals.postMessage(data);
    }

    window.parent.postMessage(data, '*');
    window.postMessage(data, '*');
}
